/**************************************************
 * Nombre:       PaginaConstruccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../Recursos/fondos.png'
import logo from '../Recursos/logo_blanco.svg'
import {NEGRITA} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";

const PaginaConstruccion = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh'

            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                            <img src={logo} width={sCell ? 280 : 350}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: 48,
                                fontWeight: 600,
                                textAlign: 'center',
                                lineHeight: 1.1
                            }}>Pagina en
                                construcción</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 4}}>
                            <Typography sx={{fontSize: 20, fontWeight: 500, textAlign: 'center'}}>
                                Muy pronto sabras de nuestro modelo de Escuelas de Aprendizaje, Metodologías Activas e
                                Innovadoras, Formación
                                Integral , Camino a la Profesionalización, Diferencial de Profundización
                            </Typography>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default PaginaConstruccion